<template>
  <p class="text-sm font-normal text-info-text dark:text-theme-nav-purple">
    <slot></slot>
  </p>
</template>
